/**
 * @param url redirect-url
 */
export function redirect(url: string) {
  window.location.href = url;
}
